module.exports = __webpack_public_path__ + "static/media/banner_slide03.d5240e29.png";